"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = exports.LINK_CLASS = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _ButtonWrapper = require("./ButtonWrapper");

var _btnPropTypes = require("./btnPropTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LINK_CLASS = 'btn-link';
/**
 * Buttons that are styled to look like links
 * you must pass children to this (many of our "links" are stylized with getNumberIcon)
 */

exports.LINK_CLASS = LINK_CLASS;

var LinkButton = function LinkButton(_ref) {
  var atts = _ref.atts,
      doFocus = _ref.doFocus,
      onClick = _ref.onClick,
      cashbotName = _ref.cashbotName,
      children = _ref.children,
      type = _ref.type,
      cssClass = _ref.cssClass,
      isCentered = _ref.isCentered;
  var btnProps = {
    cssClass: cssClass || (0, _dedupe.default)("".concat(LINK_CLASS), _defineProperty({}, "".concat(LINK_CLASS, "--center"), isCentered)),
    cashbotName: cashbotName,
    onClick: onClick,
    doFocus: doFocus,
    type: type,
    atts: atts
  };
  return _react.default.createElement(_ButtonWrapper.ButtonWrapper, btnProps, children);
};

exports.LinkButton = LinkButton;
LinkButton.defaultProps = _objectSpread({}, _btnPropTypes.linkBtnDefaults);
LinkButton.propTypes = _objectSpread({}, _btnPropTypes.commonPropTypes, {
  children: _propTypes.default.node.isRequired,
  cssClass: _propTypes.default.string,
  isCentered: _propTypes.default.bool
});